import React from 'react';

import AdListItem from '../AdListItem/AdListItem';
import { useAdListItem } from '../AdListItem/hooks';
import type { AdListOptionalFormState } from '../types';
import { isSavedAd } from '../utils/utils';

export interface AdListItemInteractiveProps {
  readonly weight: number;
  readonly adListElement: AdListOptionalFormState;
  readonly adIndex: number;
  readonly isSelected: boolean;
  readonly selectedFocusRef?: (el: HTMLLIElement) => HTMLLIElement | null;
  readonly onClick: (adIndex: number, adId?: string) => void;
  readonly onClickDelete: (adIndex: number) => void;
  readonly isAdListWithOneItem: boolean;
  readonly isSequence: boolean;
  readonly onContentChange?: () => void;
}

function AdListItemInteractive({
  adIndex,
  adListElement,
  onClick,
  onClickDelete,
  selectedFocusRef,
  isSelected,
  weight,
  isAdListWithOneItem,
  isSequence,
  onContentChange,
}: AdListItemInteractiveProps): JSX.Element {
  const { handleDeleteClick, handleItemClick, handleRemoveAd, handleSelectAd } = useAdListItem({
    adIndex,
    ad: adListElement.ad,
    onClick,
    onClickDelete,
  });

  return (
    <AdListItem
      adListElement={adListElement}
      selectedFocusRef={selectedFocusRef}
      isSaved={isSavedAd(adListElement.ad)}
      isSelected={isSelected}
      handleDeleteClick={handleDeleteClick}
      handleRemoveAd={handleRemoveAd}
      handleItemClick={handleItemClick}
      weight={weight}
      handleSelectAd={handleSelectAd}
      isAdListWithOneItem={isAdListWithOneItem}
      isSequence={isSequence}
      onContentChange={onContentChange}
    />
  );
}

export default AdListItemInteractive;
